import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import BM10120View from "../../Views/Bases/BM10120";
import Snackbar from "../../Components/Snackbar";

function BM10120(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [boardList, setBoardList] = React.useState([]);
  const [inputs, setInputs] = React.useState({
    title: "", //바코드
    remark: "",
  });
  const [checkInputs, setCheckInputs] = React.useState({
    processCd: "PRO003",
    processNm: "",
    machineCd: "",
    comboProcessCd: [],
    result: false,
  });
  const [saveData, setSaveData] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let boardData = [];
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10120.Serach,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          boardData.push({
            title: data[i].title ? data[i].title : "",
            value: data[i].remarks,
            createId: data[i].createId,
          });
        }

        setRowData(boardData);
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let getData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });

      for (let i = 0; i < rowData.length; i++) {
        getData.push({
          Title: rowData[i].title,
          Remarks: rowData[i].value,
          CreateId: rowData[i].userId ? rowData[i].userId : userInfo.userId,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10120.Create,
        {
          title: inputs.title,
          remark: inputs.remark,
          userId: userInfo.userId,
        }
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          throw new Error(data.message);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
      setChangedRowData([]);
    }
  };
  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          Title: selectedRowData[i].title,
          Remarks: selectedRowData[i].value,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10120.DeleteItemBoard,
        deleteData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <BM10120View
        Init={Init}
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        SaveConfirm={SaveConfirm}
        inputs={inputs}
        setInputs={setInputs}
        checkInputs={checkInputs}
        setCheckInputs={setCheckInputs}
        setSnackbars={setSnackbars}
        setSaveData={setSaveData}
        saveData={saveData}
        boardList={boardList}
        DeleteConfirm={DeleteConfirm}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10120;
